// CITYFARM V2 - INTERRUPTORES DE VERSION
// Cambia solamente estos valores cuando quieras cambiar qué versión se muestra.
export const CITYFARM_VERSION_FLAGS = {
  classicEnabled: true,
  v2Enabled: true,
  defaultVersion: 'v2', // 'classic' | 'v2' — V2 queda como principal
};
